import beatsPerSecond from './beatsPerSecond';

export default (tempo) => 1 / beatsPerSecond(tempo);
